import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useStoreAuth } from '../contexts/StoreAuthContext';
import NewOrderWatcher from './Store/NewOrderWatcher';
import IncomingCallWatcher from './Store/IncomingCallWatcher';

interface StoreProtectedRouteProps {
  children: React.ReactNode;
}

const StoreProtectedRoute: React.FC<StoreProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useStoreAuth();
  const location = useLocation();

  // Wait for auth check to complete before redirecting
  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Clear stale localStorage to prevent login page bounce-back loop
    localStorage.removeItem('rbf_user_data');
    localStorage.removeItem('user');
    // Redirect to shared team login with return path
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  }

  // NewOrderWatcher polls /api/store/new-orders-since/ every 20s and
  // pops a modal for each new BridgeClubOrder. Mounted here so it
  // watches every authenticated /store/* page without each page
  // having to opt in.
  return (
    <>
      <NewOrderWatcher />
      <IncomingCallWatcher />
      {children}
    </>
  );
};

export default StoreProtectedRoute;
